import { useState, useEffect } from "react";
import { X, ClockCounterClockwise, Plus, CheckCircle } from "@phosphor-icons/react";

const KEY = "contractor_first_tour_done_v1";

export default function FirstLoginTour() {
  const [step, setStep] = useState(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined" && !localStorage.getItem(KEY)) {
      setVisible(true);
    }
  }, []);

  const dismiss = () => {
    localStorage.setItem(KEY, "1");
    setVisible(false);
  };

  if (!visible) return null;

  const STEPS = [
    {
      icon: ClockCounterClockwise,
      title: "Welcome to Safety Onsite Solutions",
      body: "This app is where you'll submit your timesheet each week. Should take under 3 minutes on Sunday evenings.",
    },
    {
      icon: Plus,
      title: "Tap 'New timesheet' each Sunday",
      body: "Enter your hours for each day, add any per-diem days, and note exceptions like mileage or tolls. Hit Submit — your supervisor gets an email link right away.",
    },
    {
      icon: CheckCircle,
      title: "You'll get notified when it's approved",
      body: "Once your supervisor clicks Approve, you get a confirmation email. If they Reject with a reason, you'll get an email too — fix the issue, tap 'Resubmit', and you're done.",
    },
  ];

  const s = STEPS[step];
  const Icon = s.icon;
  const isLast = step === STEPS.length - 1;

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4"
         data-testid="contractor-first-tour">
      <div className="bg-white rounded-2xl max-w-md w-full shadow-2xl overflow-hidden">
        <div className="bg-gradient-to-br from-teal-500 to-emerald-500 text-white p-6 relative">
          <button onClick={dismiss} className="absolute top-3 right-3 text-white/80 hover:text-white"
                  data-testid="dismiss-tour">
            <X size={22} weight="bold" />
          </button>
          <Icon size={44} weight="bold" className="mb-3" />
          <div className="text-xs uppercase tracking-widest opacity-80">Step {step + 1} of {STEPS.length}</div>
          <h2 className="text-2xl font-black mt-1">{s.title}</h2>
        </div>
        <div className="p-6">
          <p className="text-slate-700 leading-relaxed">{s.body}</p>
          <div className="mt-6 flex items-center justify-between gap-3">
            <div className="flex gap-1">
              {STEPS.map((_, i) => (
                <div key={i} className={`h-1.5 w-8 rounded-full ${i <= step ? "bg-teal-500" : "bg-slate-200"}`} />
              ))}
            </div>
            <div className="flex gap-2">
              {step > 0 && (
                <button onClick={() => setStep(step - 1)}
                        className="px-3 h-9 text-slate-600 hover:text-slate-900 text-sm font-semibold">
                  Back
                </button>
              )}
              {isLast ? (
                <button onClick={dismiss} data-testid="tour-finish"
                        className="px-4 h-10 bg-green-600 hover:bg-green-700 text-white font-bold rounded-md">
                  Got it — let's go
                </button>
              ) : (
                <button onClick={() => setStep(step + 1)} data-testid="tour-next"
                        className="px-4 h-10 bg-green-600 hover:bg-green-700 text-white font-bold rounded-md">
                  Next
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
